import { render } from "./AnalyticsPerfectionDescription.vue?vue&type=template&id=9fda82fc&scoped=true"
import script from "./AnalyticsPerfectionDescription.vue?vue&type=script&lang=js"
export * from "./AnalyticsPerfectionDescription.vue?vue&type=script&lang=js"

import "@/css/components/analytics-perfection-description.css?vue&type=style&index=0&id=9fda82fc&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fda82fc"]])

export default __exports__